/*
 * @Author: your name
 * @Date: 2021-01-06 17:24:12
 * @LastEditTime: 2021-11-30 15:34:54
 * @LastEditors: Please set LastEditors
 * @Description: 修改配置需重启服务后生效
 * @FilePath: \vue3-element-admin\src\config.js
 */

module.exports = {
    dev_mock: false, //开发环境启用mock true:启用
    pro_mock: false, //生产环境启用mock true:启用
    baseUrl: {
        devService: 'http://192.168.200.233:8199/jltycpService/',
        devViewFile: 'http://192.168.200.233/view/',
        devVideoFile: 'http://192.168.200.233/video/',
        
        // proService: 'http://jlstycp.huachuangiot.com/jltycpService/',
        // proViewFile: 'http://jlstycp.huachuangiot.com/view/',
        // proVideoFile: 'http://jlstycp.huachuangiot.com/video/',
        
        // 体彩正式服务器使用
        proService: 'https://www.jlstycp.com/jltycpService/',
        proViewFile: 'https://www.jlstycp.com/view/',
        proVideoFile: 'https://www.jlstycp.com/video/',
        
        // proService: 'http://192.168.100.123:8180/jltycpService/',
        // proViewFile: 'http://192.168.100.123:8180/view/',
        // proVideoFile: 'http://192.168.100.123:8180/',
    },
};
